import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts"

interface UsageChartProps {
  data: {
    name: string
    value: number
    limit: number
    percentage: number
  }[]
  height?: number
}

export function UsageChart({ data, height = 200 }: UsageChartProps) {
  // Get color based on usage percentage
  const getBarColor = (percentage: number) => {
    if (percentage >= 90) return "#ef4444" // red-500
    if (percentage >= 75) return "#f59e0b" // amber-500
    if (percentage >= 50) return "#3b82f6" // blue-500
    return "#10b981" // green-500
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 20, right: 20, bottom: 20, left: 20 }}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
        <XAxis 
          dataKey="name" 
          className="text-xs"
          tick={{ fill: "currentColor" }}
        />
        <YAxis 
          className="text-xs"
          tick={{ fill: "currentColor" }}
        />
        <Tooltip 
          contentStyle={{ 
            backgroundColor: "hsl(var(--background))",
            border: "1px solid hsl(var(--border))",
            borderRadius: "6px",
          }}
          labelStyle={{ color: "hsl(var(--foreground))" }}
          formatter={(value: any, name: string) => {
            if (name === "usage") {
              const item = data.find(d => d.value === value)
              return [`${value} / ${item?.limit || 0} (${item?.percentage || 0}%)`, "Usage"]
            }
            return [value, name]
          }}
        />
        <Bar dataKey="value" name="usage" radius={[4, 4, 0, 0]}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={getBarColor(entry.percentage)} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}